import React , {useContext} from 'react'
import { MDBInput } from 'mdb-react-ui-kit'
import HeaderTools from '../Header/HeaderTools'
import helper from '../../Services/helper'
import UserPermissionContext from '../../components/Context/UserPermissionContext'

const Search = (props) => {
    const {userPermission} = useContext(UserPermissionContext);
    const t = (key) => {
        return helper().translate(key);
    }

    return (
        <>
            <div className={`card border-left-primary shadow h-100 ${ (props.new || props.newHandle ||props.save || props.print || props.excel || props.excelHandle || props.back ||props.backHandle) ? 'py-0' : 'py-1'}`} style={{minHeight: '0'}}>
                <div className="card-body py-0">
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2 row">
                                <div className="col-lg-12 form-group my-0 d-flex align-items-center px-0">
                                    <div className="d-table-cell no-shadow">
                                        <HeaderTools new={props.new ? props.new : ''} newHandle={props.newHandle ? props.newHandle : ''} save={props.save ? props.save : ''} saveToSale={props.saveToSale ? props.saveToSale : ''} print={props.print ? props.print : ''} printClick={props.printClick ? props.printClick : ''} digitalPrint={props.digitalPrint ? props.digitalPrint : ''} printClickAsCount={props.printClickAsCount ? props.printClickAsCount : ''} excel={props.excel ? props.excel : ''} backHandle={props.backHandle ? props.backHandle : ''} back={props.back ? props.back : ''} upload={props.upload ? props.upload : ''} importData={props.importData ? props.importData : ''} schema={props.schema ? props.schema : ''} disableSaveButton={props.disableSaveButton === true || userPermission?.find((f)=> f.moduleName === props.headersFrom )?.allowEdit === 0  ? true : ''} disableimportData={props.disableimportData} disableprintAsCount={props.disableprintAsCount}    />  
                                    </div>
                                    {(props.search || props.change) &&
                                        <div className="d-table-cell" style={{flex: 1}}>
                                            <MDBInput className="form-control-sm" label={t('SEARCH')+'...'} onChange={props.change} value={props.value} />
                                        </div>
                                    }
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Search
